module.exports = __webpack_public_path__ + "img/7DA1BA_A4CCE8_5D7A8B_5E7C94-256px.a07699d9.png";